import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getIncidentsMyWorksToAdministrateIncidents(companyId, query) {

	return dataTransferWrap(
		ModulesMap.INCIDENTS_MY_WORKS_TO_ADMINISTRATE_INCIDENTS,dtConfig[ModulesMap.INCIDENTS_MY_WORKS_TO_ADMINISTRATE_INCIDENTS].getIncidentsMyWorksToAdministrateIncidents,
		{
			urlParams: {
				companyId,
			},
			params: query,
		},
	)
}


export default {
	getIncidentsMyWorksToAdministrateIncidents,

}
